<template>
  <div class="pause">
    <video autoplay muted loop id="redVideo" :src="video">
    </video>
    <div class="red-container">
      <Header v-bind:currentTimer="0" styleType="red" hideLogo="false" />
      <div class="content-container">
        <div class="container h-100">
          <div class="row h-100">
            <div class="col-12 my-auto">
              <div class="row justify-content-center">
                <div class="col-10 col-sm-10 col-md-10 col-lg-8 pb-3 text-center">
                  <h2 v-html="$t('common.pause')"></h2>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-10 col-sm-10 col-md-10 col-lg-6 col-xl-5 pt-5">
                  <div class="error pb-3" v-if="loginError">
                    <div class="text-danger" v-if="errorType === 'wrongPassword'">
                      {{ $t('login.error.wrongPassword') }}
                    </div>
                    <div class="text-danger" v-if="errorType === 'couldNotStartChapter'">
                      {{ $t('login.error.couldNotStartChapter') }}
                    </div>
                    <div class="text-danger" v-if="errorType === 'couldNotLoginUser'">
                      {{ $t('login.error.couldNotLoginUser') }}
                    </div>
                  </div>
                  <form>
                    <div class="row form-group justify-content-center">
                      <div class="col-12 col-sm-12 col-md-5 col-lg-8">
                        <input type="password" class="form-control" v-model="password" />
                      </div>
                      <div class="col-6 col-sm-6 col-md-3 col-lg-4 pt-3 pt-md-0">
                        <button class="btn btn-danger" @click="loginToNextChapter">{{ $t('common.button.next') }}</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer type="red" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import axios from 'axios'

export default {
  name: 'Pause4',
  components: {
    Header, Footer
  },
  data: function () {
    return {
      pw: 'asdkfjhtmnbvasdfknedsfDSF',
      slide: 1,
      currentTimer: 0,
      password: '',
      loginPassword: '131616',
      loginError: false,
      errorType: ''
    }
  },
  computed: {
    video: function () {
      return 'https://tabbot-central.b-cdn.net/video/BinaryNumbers2.mp4'
    }
  },
  methods: {
    loginToNextChapter: function () {
      event.preventDefault()
      this.errorType = ''
      this.loginError = false
      if (this.password !== this.loginPassword) {
        this.loginError = true
        this.errorType = 'wrongPassword'
        return
      }
      this.startChapter()
    },
    startChapter: function () {
      axios.get('http://admin.tabbot-central.com/setTimer.php', {
        params: {
          token: this.pw,
          chapter: 5
        }
      }).then(response => {
        this.$store.commit('reloadGameData', true)
      }).catch(error => {
        console.log(error)
        this.errorType = 'couldNotStartChapter'
        this.loginError = true
      })
    }
  }
}
</script>
